"use client";

import { createContext, useContext } from "react";

import type {
  ConsentCategories,
  ConsentChoice,
  ConsentRegion,
} from "@/lib/cookie-consent";

export interface CookieConsentContextValue {
  // False during SSR and the first client render; region/choice are only known
  // after the cookie is read in a mount effect. Consent UI keys off this to
  // avoid hydration mismatches.
  mounted: boolean;
  region: ConsentRegion;
  choice: ConsentChoice | null;
  isPreferencesOpen: boolean;
  openPreferences: () => void;
  closePreferences: () => void;
  acceptAll: () => void;
  rejectAll: () => void;
  saveChoice: (categories: ConsentCategories) => void;
}

export const CookieConsentContext =
  createContext<CookieConsentContextValue | null>(null);

export function useCookieConsent(): CookieConsentContextValue {
  const ctx = useContext(CookieConsentContext);
  if (!ctx) {
    throw new Error(
      "useCookieConsent must be used within a CookieConsentProvider",
    );
  }
  return ctx;
}
